export default __webpack_public_path__ + "static/media/malaysia.b7552a63.webp";